import React, { useEffect, useRef } from 'react';

// Wraps a screen section that depends on the section before it. While `locked`
// the section is greyed out and cannot be clicked, tabbed into or typed in;
// `hint` explains what unlocks it. Everything inside stays mounted, so values
// already entered are not lost when the lock toggles.
function SectionLock({ locked, hint, children, testId }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.inert = !!locked;
  }, [locked]);

  return (
    <div
      ref={ref}
      aria-disabled={locked ? 'true' : undefined}
      title={locked ? hint : undefined}
      data-testid={testId}
      style={locked ? { opacity: 0.5, pointerEvents: 'none', userSelect: 'none' } : undefined}
    >
      {children}
    </div>
  );
}

export default SectionLock;
